import swal from 'sweetalert2'

export const generalMixins = {
  methods: {
    resetSiteDueInvalidCart: function () {
      localStorage.removeItem('id_cart')
      this.$router.replace({name: 'e3d'})
      swal.fire({
        title: 'Errore carrello',
        text: 'Si sono verificati dei problemi con il tuo carrello',
        icon: 'error'
      })
    },
    badRequestModal: function (data) {
      if (data.error && Object.keys(data.error).length > 0) {
        let errorMessage = ''
        Object.keys(data.error).forEach((key) => {
          let msg = data.error[key].toString().replace('does not contains only allowed chars', 'contiene caratteri non permessi')
          errorMessage += '<b>' + key + '</b>: ' + msg + '<br>'
        })
        swal.fire({
          title: 'Errore validazione',
          html: errorMessage,
          icon: 'error'
        })
      } else {
        swal.fire({
          title: 'Errore salvataggio',
          text: 'Si sono verificati dei problemi con il salvataggio delle informazioni. Verifica che le informazioni inserite siano corrette',
          icon: 'error'
        })
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/generalMixins.js